import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './views/store'
import './assets/css/common.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/izmir.min.css'
import animate from 'animate.css'
import SIdentify from './components/identify/identify'
import VueLazyload from 'vue-lazyload'

Vue.use(SIdentify)
Vue.use(animate)
Vue.use(ElementUI);
Vue.use(VueLazyload,{
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})
router.beforeEach((to, from, next) => {
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
      next();
});

import axios from 'axios';
const Axios = axios.create({
  //请求接口
  baseURL: "https://www.baochengtech.com/official_website_new/api",
  //超时设置
  timeout: 3000,
  //请求头设置
  headers: {
    "accept": "application/json",
    'Content-Type': 'application/json',
  }
})
// 添加请求拦截器
Axios.interceptors.
request.use(
  function (config) {
    let token = window.localStorage.getItem("token");
    if (token) {
      config.headers.common['token'] = window.localStorage.getItem("token");
    }
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
//添加相应拦截器
Axios.interceptors.response.use(
  function (response) {
    //对相应数据做点什么
    return response;
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 202:
          //返回 401 清除token信息并跳转到登录页面
          localStorage.removeItem("token");
          router.push("./components/Login.vue");
          break;
      }
    }
    return Promise.reject(error);
  }
)

Vue.prototype.axios = Axios;
//将axios挂载到Vue的原型上
Vue.prototype.$http = Axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')